export const ClinicSelect = resolve => require(["./clinic-select"], resolve); // 委托单位列表
export const FactorySelect = resolve => require(["./factory-select"], resolve); // 工厂列表

export const ToothColorSelect = resolve => require(["./tooth-color-select"], resolve); // 牙齿颜色列表
export const ExpressCompanySelect = resolve => require(["./express-company-select"], resolve); // 快递
